"use strict";
// import { V2 } from "../V2/index.js";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./Governance/index.js"), exports);
__exportStar(require("./ScriptContext/index.js"), exports);
__exportStar(require("./Tx/index.js"), exports);
// import { PChangedParams, PDrep, PGovernanceAction, PProposalProcedure, PProtocolVersion, PVote, PVoter, PConstitution, PRational } from "./Governance/index.js";
// import { PCertificate, PDelegatee, PScriptContext, PScriptInfo, PScriptPurpose, PTxInfo } from "./ScriptContext/index.js";
// import { PTxId, PTxInInfo, PTxOutRef } from "./Tx/index.js";
// @ts-ignore The inferred type of this node exceeds the maximum length the compiler will serialize. An explicit type annotation is needed.ts(7056)
// export const V3 = Object.freeze({
//     ...V2,
//     
//     PChangedParams, PDrep, PGovernanceAction, PProposalProcedure, PProtocolVersion, PVote, PVoter, PConstitution, PRational,
//     PCertificate, PDelegatee, PScriptContext, PScriptInfo, PScriptPurpose, PTxInfo,
//     PTxId, PTxInInfo, PTxOutRef
// } as const);
